import { BNRichText } from "@bn-monorepo/js-packages";
import { useMemo } from "react";

export interface IPriceExample {
  text: string;
  textAlign: "inherit" | "left" | "center" | "right";
  fontSizeEm: number;
}

const PriceExample: ReactFCWithNoJs<IPriceExample> = (props) => {
  const { text, textAlign, fontSizeEm } = props;

  const sx = useMemo(
    () => ({
      textAlign,
      margin: "1em 0",
      fontSize: fontSizeEm ? `${fontSizeEm}em` : { xs: "1.4rem", sm: "1.6rem" },
    }),
    [textAlign, fontSizeEm],
  );

  return <BNRichText html={text} sx={sx} />;
};
PriceExample.noJsRequired = true;
export default PriceExample;
